export default function initsmc(){
    $('.smc__nl').find('.checkinput').on("change", function(){
        const button = $(this).parents('.smc__nl').find('button[type="submit"]');
        const form = $(this).parents(".smc__nl");
        const checkboxNum = form.find("[type='checkbox']").length;
        const allChecked = form.find("[type='checkbox']").filter(function(e,node){
            return $(node).is(":checked");
        }).length === checkboxNum;
        if(allChecked){
            button.attr("disabled",null)
            console.log('removing prop');
        }else{
            button.attr("disabled","disabled")
            console.log('setting prop');
        }
    });
    $('.smc').each(function(){
        let smc = $(this);
        let list = smc.find('.smc__list');
        let content = smc.find('.smc__content');
        let ol = smc.find('.smc__stickywrapper');
        let burger = smc.find('.smc__burger');
        const stopper = smc.find('.smc__navstopper');

        if(window.innerWidth < 1024){
            list.removeClass("smc__list--active");
        }

        burger.on('click', function(){
            list.toggleClass('smc__list--active');
            setStickyBurger();
        });

        let navHeight = 0;
        if(window.innerWidth < 1024){
            navHeight = $(".stickheader").height();
        }
        else{
            navHeight = Math.max($('.mainnav-mobile').height(), $('.mainnav-desk').height());
        }

        function setStickyBurger(){
            const contentbcr = content.get(0).getBoundingClientRect();
            const maxScroll = contentbcr.y + contentbcr.height - ol.height();

            if(contentbcr.top - navHeight <= 0 ){ //sticky threshhold
                ol.attr('style', '');
                const olbcr = ol.get(0).getBoundingClientRect();
                ol.css('position', 'fixed');
                ol.css('left', olbcr.x + 'px');
                ol.css('width', olbcr.width + 'px');
                ol.css('top',Math.min(navHeight, maxScroll) + 'px');
            }
            else{
                ol.attr('style', '');
            }
        }

        $(window).on('scroll resize burgerClicked', setStickyBurger);
        setStickyBurger();

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('smc__contentelement--show');
                    // Perform desired actions when the element is in the bottom 40%
                }
            });
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.6
        });

        content.find('p, img, .smc__stickywrapper li').each(function(){
            observer.observe(this);
        });



    });
}